import React from "react";
import { connect } from 'react-redux'

import { teachersActions } from '../actions';

import { Spinner } from 'components/Icons/Spinner';
import { Row, Card, CardBody, CardFooter } from "reactstrap";


import { CourseSubjectHeader } from '../components/CourseSubjectHeader';

var viewActions = require ('store/view.actions');
  
 


class CourseSubjectNotebook extends React.Component {

  componentDidMount() {
    this.props.getCourseSubject (this.props.token,  this.props.match.params.course_subject_id) ;
    
    // if (this.props.courseStudents.length===0)
      // this.props.getCourseSubjectStudents (this.props.token,  this.props.match.params.course_subject_id) ;

      this.props.setBreadCrumb(
                  [{title:'Mis Cursos', link:'/admin/my-courses'}  ],  'Datos del curso')
  }



  constructor(props) {
    super(props);
    this.state = {
      elvalor: 45
    }

 }

 modificaElValor ( val) {

   this.setState({elvalor: val })
}


  render() {
    return (
      <>
        <div className="content">
        {this.props.courseSubject.course_subject_id && !this.props.view.loadingModules.getCourseSubject ?
            <Card  >

              <CourseSubjectHeader 
                        courseSubject={this.props.courseSubject} />


              <CardBody>
                  <Row>
                  Info del curso
                  
                  {/* <table>
                    <tr>
                      <td width="100" style={{border: "1px solid"}}> 1 </td>
                      <td width="100" style={{border: "1px solid"}}> 
                      <EditableCell 
                        type="number"
                        defaultValue={this.state.elvalor} 
                        
                        updateValue={this.modificaElValor.bind(this)} />
                         </td>


                      <td width="100" style={{border: "1px solid"}}> 
                        <EditableCell 
                          readOnly
                          defaultValue="19" /> 
                      </td>
                    </tr>
                    <tr>
                      <td width="100" style={{border: "1px solid"}}> 1 </td>
                      <td width="100" style={{border: "1px solid"}}> 
                      <EditableCell defaultValue="981" /> </td>
                      <td width="100" style={{border: "1px solid"}}> 
                        <EditableCell 
                          textAlign="right"
                          defaultValue="19" /> 
                      </td>
                    </tr>
                  </table> */}
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                
              </CardFooter>
            </Card>
            
        :
        <Spinner size="XL" />
      }
        </div>
      </>
    );
  }
}

 const mapStateToProps = state => {
    return {
        token: state.auth.session.jwt_token,
        currentCalendarID:  state.school.currentCalendarID,
        view: state.view,
        user: state.auth.session.user,
        courseSubject: state.teachers.courseSubject 
     }
  }

  
  const mapDispatchToProps = dispatch => {
    return { 
        getCourseSubject: (token, courseSubjectID) => {
            dispatch(teachersActions.getCourseSubject(token, courseSubjectID));
        } , 
        setBreadCrumb: ( breadCrumb, activeTitle ) => {
          dispatch(viewActions.setBreadCrumb( breadCrumb, activeTitle ))
        },

        getCourseSubjectStudents: (token, courseSubjectID ) => {
          dispatch(teachersActions.getCourseSubjectStudents(token, courseSubjectID));
        }
        // updatePersona: (token, personaID , data) => {
        //   dispatch(personasActions.updatePersona(token, personaID , data , false));
        // }
      
 
    }
  }


  export default connect(mapStateToProps, mapDispatchToProps)(CourseSubjectNotebook);

